import React from 'react'

import MuiLink from '@mui/material/Link'

import { Log } from '../../types/log'

interface InventoryLinkProps {
  log: Log | null
}

const InventoryLink = (props: InventoryLinkProps): JSX.Element => {
  const inventoryId = props.log?.inventory_id || props.log?.inventory_id
  const inventoryName = props.log?.inventory_name || props.log?.inventory_name || props.log?.bean_name

  return inventoryId && inventoryName ? (
    <MuiLink href={`/inventories/${inventoryId}`} target="_blank" rel="noopener noreferrer">
      {inventoryName}
    </MuiLink>
  ) : (
    <span>{inventoryName || 'N/A'}</span>
  )
}

export default InventoryLink
